const menuData = [
  {
    id: 1,
    title: "Home",
    path: "/",
    type: "page",
  },
  {
    id: 2,
    title: "Why DevFest",
    path: "/#why-devfest",
  },
  {
    id: 3,
    title: "Takeaways",
    path: "/#takeaways",
  },
  {
    id: 4,
    title: "Venue",
    path: "/#venue",
  },
  {
    id:5,
    title: "Sponsors",
    path:"/#sponsors",
  },
  {
    id: 6,
    title: "FAQ's",
    path: "/#faq",
  },
  {
    id: 7,
    title: "Team",
    path: "/team",
    type: "page",
  },
];

export default menuData;
